import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import AuthLoader from '../../Components/Helper/AuthLoader';
import { setUserFromLocalStorage } from '../../Store/userSlice';
import { isSuperAdmin, isInstituteAdmin } from '../../utils/roleUtils';

const InstituteAdminCheck = ({ element }) => {
  const user = useSelector((state) => state.user.user);
  const dispatch = useDispatch();
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    // If no user in Redux, try to load from localStorage
    if (!user || !user.email) {
      dispatch(setUserFromLocalStorage());
    }
    setIsLoaded(true);
  }, [dispatch, user]);

  // Show loading while checking authentication
  if (!isLoaded) {
    return <AuthLoader />;
  }

  // Check if user is logged in
  if (!user || !user.email) {
    return <Navigate to="/teacher-login" replace />;
  }

  // Check if user is an institute admin OR a super admin
  // Super admins have access to all institute admin features
  const hasAccess = isInstituteAdmin(user) || isSuperAdmin(user);

  if (!hasAccess) {
    return <Navigate to="/myprofile" replace />;
  }

  // User is authenticated and has admin access
  return element;
};

InstituteAdminCheck.propTypes = {
  element: PropTypes.node.isRequired,
};

export default InstituteAdminCheck;
